import {useFormContext} from 'react-hook-form'
import {graduation} from "../../enum/physicalExamOptions";
import SimpleSelectField from "../SimpleSelectField";
import MultiOptionSelectField from "../MultiOptionSelectField";
import React, {useEffect} from "react";
import {Button, Grid} from "@material-ui/core";
import {InputField} from "components";
import generateProgression from "../../functions/generateProgression";

const Tornozelo = ({id, segment, segmentName, removeItems, isPreview = false}) => {
    const {control, watch, setValue} = useFormContext()
    const watchAmputationField = watch(`${id}.${segment}.01-amputation`)

    useEffect(()=>{
                    setValue(`${id}.${segment}.02-amputationLevel`, null);
    },[watchAmputationField]);
    return (
        <>
            {!isPreview && (
                <Button style={{width: '100%', fontWeight: '900', fontSize: 'medium', backgroundColor: 'red'}}
                        variant={'contained'}
                        size='large'
                        color='secondary'
                        onClick={() => removeItems(segmentName,segment)}
                >
                    Excluir Exame
                </Button>
            )}
            <Grid container spacing={1} className="form-grid" justifyContent="center">
                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'01-amputation'}
                        label={'Amputação'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                {
                    watchAmputationField === 1 &&
                    <Grid item sm={10} md={5}>
                        <InputField
                            id={id}
                            name={`${id}.${segment}.02-amputationLevel`}
                            label={'Nível de Amputação'}
                            control={control}
                        disabled={isPreview}/>
                    </Grid>
                }

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'03-march'}
                        label={'Marcha'}
                        trueLabel={'Normal'}
                        falseLabel={'Alterado'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'04-squat'}
                        label={'Agachamento'}
                        trueLabel={'Normal'}
                        falseLabel={'Alterado'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'05-shortening'}
                        label={'Encurtamento'}
                        trueLabel={'Normal'}
                        falseLabel={'Alterado'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <MultiOptionSelectField
                        segment={segment}
                        id={id}
                        name={'06-dorsiflexion'}
                        label={'Flexão Dorsal'}
                        control={control}
                        options={generateProgression(0, 25, 5)}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <MultiOptionSelectField
                        segment={segment}
                        id={id}
                        name={'07-plantarFlexion'}
                        label={'Flexão Plantar'}
                        control={control}
                        options={generateProgression(0, 50, 5)}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'08-atrophies'}
                        label={'Presença Atrofias'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'09-passiveMobilization'}
                        label={'Mobilização Passiva'}
                        trueLabel={'Normal'}
                        falseLabel={'Anormal'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'10-operativeScar'}
                        label={'Cicatriz operatória'}
                        trueLabel={'Existente'}
                        falseLabel={'Inexistente'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'11-sensitivity'}
                        label={'Sensibilidade'}
                        trueLabel={'Normal'}
                        falseLabel={'Anormal'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'12-coloring'}
                        label={'Coloração'}
                        trueLabel={'Normal'}
                        falseLabel={'Anormal'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'13-temperature'}
                        label={'Temperatura'}
                        trueLabel={'Normal'}
                        falseLabel={'Anormal'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'14-inflammatorySigns'}
                        label={'Sinais Inflamatórios'}
                        trueLabel={'Existente'}
                        falseLabel={'Inexistente'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'15-muscleChanges'}
                        label={'Alterações Musculares'}
                        trueLabel={'Existente'}
                        falseLabel={'Inexistente'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'16-motorChanges'}
                        label={'Alterações Motoras'}
                        trueLabel={'Existente'}
                        falseLabel={'Inexistente'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <SimpleSelectField
                        segment={segment}
                        id={id}
                        name={'18-segmentOrMember'}
                        label={'A lesão se limita ao segmento ou membro inferior?'}
                        trueLabel={'Segmento'}
                        falseLabel={'Membro'}
                        control={control}
                        disabled={isPreview}/>
                </Grid>

                <Grid item sm={10} md={5}>
                    <MultiOptionSelectField
                        segment={segment}
                        id={id}
                        name={'17-graduation'}
                        label={'Graduação'}
                        control={control}
                        options={graduation}/>
                </Grid>
            </Grid>
        </>
    )
}

export default Tornozelo
